import React, {Component} from 'react'
import { Redirect } from 'react-router-dom'
import * as config from '../Configuration/Config.js'
// import UserProfile from '../Configuration/UserProfile.js'

class AdminSecurityRoleProfile extends Component {
    constructor() {
        super();

        this.handleChange = this.handleChange.bind(this)
        this.handleChangeDashboards = this.handleChangeDashboards.bind(this)
        this.handleChangeVisualizations = this.handleChangeVisualizations.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.fetchDashboardsList = this.fetchDashboardsList.bind(this)
        this.fetchVisualizationsList = this.fetchVisualizationsList.bind(this)

        this.state = {
            is_loaded: false,
            has_error: false,
            error_message: '',
            redirect_back: false,
            customer_id: 0,
            division_id: null,
            division: null,
            visualizations: [],
            dashboards: []
        }
    }

    setRedirect() {
        this.setState({redirect_back: true});
    }

    setError(message){
        this.setState({has_error: true, error_message: message});
    }

    componentDidMount() {
        // const user_id = this.props.match.params.uid;
        const customer_id = this.props.match.params.cid;
        const id = this.props.match.params.id;

        if (!customer_id || !id) {
            this.setState({ is_loaded: true, role: null, customer_id: 0, id: null });
            return;
        }

        if (id === 'new') {
            const data = {
                id: id,
                customer_id: customer_id,
                bunsiness_division_name: '',
                sort_order: 0,
                visualizations: [],
                dashboards: []
            };

            this.fetchVisualizationsList(customer_id, id, data);
            return;
        }

        var that = this;
        const uri = config.getUriPath('businessdivisions/' + id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
                if (response.status >= 400) {
                    console.log(response);
                    throw new Error("Bad response from server");
                }

                return response.json();
          })
          .then(function(data) {
            //console.log(data);
            that.fetchVisualizationsList(customer_id, id, data);
        });
    }

    fetchVisualizationsList(customer_id, division_id, division) {
        var that = this;
        const uri = config.getUriPath('visualizations/' + customer_id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) {
            //console.log(data);
            that.fetchDashboardsList(customer_id, division_id, division, data);
          });
    }

    fetchDashboardsList(customer_id, division_id, division, vizList) {
        var that = this;
        const uri = config.getUriPath('dashboards/' + customer_id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) {
              //console.log(data);
              that.setState({ is_loaded: true, customer_id: customer_id, division_id: division_id, division: division, visualizations: vizList, dashboards: data });
          });
    }

    handleSave(event) {
        event.preventDefault();

        const division = this.state.division;
        // console.log(division);
        if (!division.business_division_name){
            // alert(division.business_division_name)
            this.setError('Business Division Name is required');
            return;
        }

        if ((!division.visualizations || division.visualizations.length === 0) &&
                (!division.dashboards || division.dashboards.length === 0)) {
            this.setError('A business division must have at least 1 dashboard or visualization');
            return;
        }

        var that = this;
        const id = this.state.division_id;
        let uriId = '';
        let method = 'post';
        if (id !== "new") {
            uriId = '/' + id;
            method = 'put';
        }

        const uri = config.getUriPath('businessdivisions' + uriId);
        fetch(uri, {
            method: method,
            headers: config.ApiHeaders(),
            body: JSON.stringify(division)
        }).then(function(response) {
            if (response.status >= 400) {
              console.log(response);
              throw new Error("Bad response from server");
            }

            that.setRedirect();        
        });
    }

    handleDelete(event) {
        event.preventDefault();

        var that = this;

        const uri = config.getUriPath('businessdivisions/' + this.state.division_id)
        fetch(uri, {
            method: 'delete',
            headers: config.ApiHeaders()
        }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }

            that.setRedirect();        
        });
    }

    handleCancel(event) {
        event.preventDefault();

        this.setRedirect();        
    }

    handleChange(event) {
        let data = this.state.division;
        data[event.target.name] = event.target.value;
        this.setState({division: data});
    }

    handleChangeDashboards(e) {
        let division = this.state.division;
        if (e.target.checked) {
            division.dashboards.push(e.target.name);
        } else {
            division.dashboards = division.dashboards.filter(x => x !== e.target.name);
        }

        this.setState({division: division});
    }

    handleChangeVisualizations(e) {
        let division = this.state.division;
        if (e.target.checked) {
            division.visualizations.push(e.target.name);
        } else {
            division.visualizations = division.visualizations.filter(x => x !== e.target.name);
        }

        this.setState({division: division});
    }

    render() {
        if (this.state.is_loaded === false) {
            return <div></div>
        }

        if (this.state.redirect_back){
            return <Redirect to={'/admin/business/divisions/' + this.state.customer_id } />
        }

        const {division_id, division, customer_id} = this.state;

        if (!division_id || customer_id === 0 || !division) {
            return <h1>No division selected</h1>
        }

        if (!division.dashboards){
            division.dashboards = [];
        }

        if (!division.visualizations){
            division.visualizations = [];
        }

        const title = (division_id === "new") ? "Create New Business Division" : "Edit Business Division: " + division.business_division_name
        return  <div>
                    <div className="center-div">
                        <h1>{title}</h1>
                    </div>
                    <br />
                    <div className="form-wrapper-bd">
                    <form>
                    <div className="container-fluid">
                        <div className="form-group">
                            <label htmlFor="customer_name">Business Division Name:</label>
                            <input type="text" onChange={this.handleChange} className="form-control" name="business_division_name" defaultValue={division.business_division_name}/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="sort_order">Sort Order:</label>
                            <input type="text" onChange={this.handleChange} className="form-control" name="sort_order" defaultValue={division.sort_order}/>
                        </div>
                        <div className="row">
                            <div className="col-md-6 dashboard-roles role-checkboxes">
                                <h3>Dashboards</h3>
                                <div className="form-group">
                                    {this.state.dashboards.map((item) => {
                                        return (
                                            <div className="form-check" key={item.id}>
                                                <input className="form-check-input" type="checkbox" value="" name={item.id} id={item.id} onChange={this.handleChangeDashboards} defaultChecked={division.dashboards.indexOf(item.id) !== -1} />
                                                <label className="form-check-label" htmlFor={item.id}>{item.display_name}</label>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="col-md-6 dashboard-roles role-checkboxes">
                                <h3>Visualizations</h3>
                                <div className="form-group">
                                        {this.state.visualizations.map((item) => {
                                            return (
                                                <div className="form-check" key={item.id}>
                                                    <input className="form-check-input" type="checkbox" value="" name={item.id} id={item.id} onChange={this.handleChangeVisualizations} defaultChecked={division.visualizations.indexOf(item.id) !== -1} />
                                                    <label className="form-check-label" htmlFor={item.id}>{item.display_name}</label>
                                                </div>
                                            )
                                        })}
                                </div>
                            </div>
                        </div>
                        <div className={this.state.has_error ? "form-group" : "hidden"}>
                            <div className="errorMsg">{this.state.error_message}</div>
                        </div>
                        <div className="form-group">
                            <div className="centerAlign" colSpan="2">
                                <button onClick={this.handleSave} name="save" className="loginButtonBD btn btn-primary">Save</button>
                                &nbsp;&nbsp;
                                <button onClick={this.handleDelete} name="delete" className={division_id === "new" ? "hidden" : "loginButtonBD btn btn-danger"}>Delete</button>
                                &nbsp;&nbsp;
                                <button onClick={this.handleCancel} name="cancel" className="loginButtonBD btn btn-info">Cancel</button>
                            </div>
                        </div>
                    </div>    
                    </form>
                    </div>
                </div>
    }
}

export default AdminSecurityRoleProfile


// WEBPACK FOOTER //
// ./src/Components/AdminBusinessDivisions/AdminBusinessDivisionProfile.js